export default __webpack_public_path__ + "static/blog-image-1-51fb7a33c219abca3e91f540e112d39e.png";